module.exports = __webpack_public_path__ + "img/5.7836eb00.png";